import { __, compose, or, path } from 'ramda'
import { capitalizeIfLower, fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import FieldValuesPresenter from '../../../containers/fieldValues/FieldValuesPresenter'
import LabelValue from '../../../packages/kiti/components/presentation/LabelValue'
import UserPresenter from '../../../containers/users/UserPresenter'
import { useSessionPermission } from '@btime/react-session'
import { useContract } from './_load/ContractLoader'

const UserDetails = () => {
  const contract = useContract()
  const { t } = useTranslation('contracts')

  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')

  let { appVersion, os, lastSeen } = contract.user.mobileDetails || {}

  const groupName = compose(capitalizeIfLower, path(['contract', 'group', 'name']))(contract.user)

  lastSeen = compose(or(__, null), fromNow)(lastSeen)

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="50%">
        <LabelValue label={t('email')} value={contract.user.email} />
      </Col>

      <Col width="50%">
        <LabelValue label={t('profile')} value={contract.user.contract?.profile?.label || contract.profile?.label} />
      </Col>

      {!!contract.user.parent && (
        <Col width="50%">
          <LabelValue label={t('linkedUser')}>
            <UserPresenter user={contract.user.parent} />
          </LabelValue>
        </Col>
      )}

      {!!groupName && (
        <Col width="50%">
          <LabelValue label={t('group')} value={groupName} />
        </Col>
      )}

      {!!lastSeen && (
        <Col width="50%">
          <LabelValue label={t('lastSeen')} value={lastSeen} />
        </Col>
      )}

      {!!appVersion && !!os && (
        <Col width="50%">
          <LabelValue label={t('appVersion')} value={`${appVersion} (${os})`} />
        </Col>
      )}

      <Col width="100%">
        <FieldValuesPresenter fieldValues={contract.fieldValues} hideConfidential={!canSeeConfidentialFields} />
      </Col>
    </Grid>
  )
}

export default UserDetails
